<template>
  <div>
   <loading :status="loading" />
    <div v-if="!loading">
    <div class="space-x-2 flex justify-between">
      <qr-code v-if="order.qr_link" :size="Number(app.printer.qr_code_size)" :color="app.printer.font_color" :text="`${order.qr_link}`"></qr-code>
     <h2 class="w-full font-bold tracking-wider uppercase">
          <strong class="text-2xl">{{ app.name }}</strong>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </h2>
    </div>
    <div class="flex items-center mt-2">
      <label class="min-w-32 block font-bold uppercase">{{ $t('Buy product invoice date') }}</label>
      <span class="mr-4 inline-block">:</span>
      <div>{{ order.created_at }}</div>
    </div>
    <div class="flex items-center">
      <label class="min-w-32 block font-bold uppercase">{{ $t('Buy product Invoice ID') }}</label>
      <span class="mr-4 inline-block">:</span>
      #{{ order.tracking }} [ {{ order.id }} ]
    </div>

    <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
      <div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Customer name') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.name | capitalize }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Customer phone') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.phone | capitalize }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Customer email') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.email | capitalize }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Customer address') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.address | capitalize }}</div>
        </div>
      </div>
    </div>
    <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
      <div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Device model') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.model }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('IMEI') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.imei }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Serial number') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.serial_number }}</div>
        </div>
        <div class="flex items-center">
          <label class="min-w-32 block font-bold uppercase">{{ $t('Quantity') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ order.qty }}</div>
        </div>
      </div>
    </div>

    <div class="w-full mb-1 mt-1 py-1 overflow-hidden">
      <div class="px-1 flex justify-between font-semibold">
        <p>{{ $t('Price') }} :</p>
        <p class="pl-2">{{ order.price | currency }}</p>
      </div>
    </div>
    <div class="pt-2">
      <template v-if="app.terms.custom_products">
        <div class="font-bold text-left">
          {{ $t('I acknowledge the following terms and conditions') }}
        </div>
        <div class="terms px-5">
          <p v-html="app.terms.custom_products"></p>
        </div>
      </template>
      <div class="flex justify-between">
        <div class="font-bold flex-1">
          {{ $t('Signature') }}
        </div>
        <div class="font-sm">------------------------------</div>
      </div>
    </div>
    <div class="flex place-content-center">
      <barcode width="1" :lineColor="app.printer.font_color" :value="order.tracking" class="self-center" height="25" />
    </div>
  </div>
</div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'custom-bill',
  metaInfo() {
    return {
      title: this.$i18n.t('Print bill order'),
    };
  },
  components: {
    'qr-code': VueQRCodeComponent,
    barcode: VueBarcode,
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      order: {
        qr_link: null,
        tax: {
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  mounted() {
    this.getCustomProductOrder();
  },
  methods: {
    getCustomProductOrder() {
      this.loading = true;
      axios
        .get(route('print-custom-product-order', this.$route.params.uuid))
        .then((response) => {
          this.order = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
